import React, { useState } from 'react';
// @ts-ignore
import { CSVLink } from 'react-csv';
import IconButton from '@mui/material/IconButton';
import { Download as DownloadIcon } from '@mui/icons-material'
import { useTranslation } from "react-i18next";
import Menu from '@mui/material/Menu';
import { Button } from '@mui/material';

export interface UcButtonGenerationChartDownloadV2Props {
    data: any[];
    filename: string;
    palletColor: string;
    selectedMeter: string;
    uom: string;
}

export const UcButtonGenerationChartDownloadV2 = (props: UcButtonGenerationChartDownloadV2Props) => {
    const { t } = useTranslation();
    const { data, filename, palletColor, selectedMeter, uom } = props;
    const csvLink = React.useRef<any>();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleCSVClick = () => {
        csvLink.current.link.click();
        setAnchorEl(null);
    }

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const modifiedData = data.map((item: any) => {
        let result: any = {};
        result["Meter Number"] = selectedMeter;
        result["Interval"] = item.label;
        result[`Generation (${uom})`] = item.totalUsage?.toFixed(2);
        result["Billing Period Start"] = item.billingPeriodStart;
        result["Billing Period End"] = item.billingPeriodEnd;

        return result;
    });

    return (
        <>
            <IconButton
                sx={{ color: palletColor }}
                onClick={handleClick}
                title={t('Generation Download')}
            >
                <DownloadIcon />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <Button onClick={handleCSVClick} style={{ display: 'inline-block', width: '200px', textAlign: 'justify' }} >
                    <span style={{verticalAlign: 'middle'}}>
                        <img src="/csv-logo.svg" style={{ margin: '0px 5px 0px 5px', verticalAlign: 'middle' }} 
                            alt="CSV Logo" width="35" height="35" /> <span style={{verticalAlign: '-2px'}}>CSV</span>
                    </span>
                </Button>
            </Menu>
            <CSVLink
                style={{ display: "none" }}
                data={modifiedData}
                filename={filename}
                ref={csvLink}
            />
        </>
    )
}